import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import StockFinder from 'brastrap/promotional/stock-finder/StockFinder';
import { MODAL_ID, FORM_ID } from 'shared/constants/stock-finder';
import {
  apiFindStock,
  close,
  closeSizeSelect,
  open,
  openSizeSelect,
  selectSkuAndCloseSizeSelect,
} from 'shared/actions/stock-finder';

const StockFinderForm = reduxForm({
  form: FORM_ID,
  fields: ['location'],
})(StockFinder);

const mapStateToProps = ({ layer, product, shopFinder, stockFinder }) => {
  const { data, selectedSku = {} } = product.styleColour;

  const selected = selectedSku || {};

  return {
    ...stockFinder,
    selectedSku,
    shopFinder,
    sizeSelect: {
      isOpen: layer.target === MODAL_ID && layer.isVisible,
      modalId: MODAL_ID,
      sizes: data.sizes,
      value: selected.skuCode,
    },
    sku: {
      item: {
        brandName: data.brand,
        colour: data.colour.colour,
        colourSwatch: data.colour.swatch,
        swatchPatternImage: data.colour.swatchPatternImage,
        imgUrl: ((data.images || [])[0] || {}).thumbnail,
        size: { size: selected.label },
        styleCode: data.styleCode,
        styleName: data.styleName,
      },
    },
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  onClose: () => dispatch(close()),
  onOpen: () => dispatch(open()),
});

const mergeProps = (state, { dispatch, ...dispatchProps }, ownProps) => {
  const skuId = (state.selectedSku || {}).id;
  return {
    ...state,
    ...dispatchProps,
    ...ownProps,

    shopFinder: {
      ...state.shopFinder,
      onBrowse: e => {
        e.preventDefault();
        return dispatch(apiFindStock(skuId));
      },
      onChoosePostCode: postCode => dispatch(apiFindStock(skuId, postCode)),
    },
    sizeSelect: {
      ...state.sizeSelect,
      onChange: sku => dispatch(selectSkuAndCloseSizeSelect(sku)),
      onModalOpen: () => dispatch(openSizeSelect()),
      onModalClose: () => dispatch(closeSizeSelect()),
    },
    onSubmit: ({ location }) => dispatch(apiFindStock(skuId, location)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(StockFinderForm);
